import { fetchSignout } from '../../app/api/signout';
import { useEnvContext } from '../../modules/EnvProvider';
import mrtApiCall from '../../shared/api/mrtApiCall';
import createToast from '../../shared/designSystem/components/Toast/createToast';

export default function useSignOut() {
  const { targetEnv } = useEnvContext();

  const handleSignOut = async () => {
    const { data, error } = await mrtApiCall(() => fetchSignout(targetEnv));
    const { status, message } = data?.result || {};

    if (status === 204 && !error) {
      window.location.reload();
    } else {
      createToast(message || '로그아웃에 실패했습니다', {
        color: 'warning',
      });
    }
  };

  return { handleSignOut };
}
